module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "types"
  }, [_c('h2', [_vm._v("Types")]), _vm._v(" "), _c('h3', {
    staticClass: "mt-font--body20"
  }, [_vm._v("Error")]), _vm._v(" "), _c('div', {
    staticClass: "mt--text-right"
  }, [_c('mt-button', {
    attrs: {
      "type": "secondary-gray"
    },
    on: {
      "click": function($event) {
        _vm.notiFlag('error')
      }
    }
  }, [_vm._v("Open Error Flag")])], 1), _vm._v(" "), _c('h3', {
    staticClass: "mt-font--body20"
  }, [_vm._v("Warning")]), _vm._v(" "), _c('div', {
    staticClass: "mt--text-right"
  }, [_c('mt-button', {
    attrs: {
      "type": "secondary-gray"
    },
    on: {
      "click": function($event) {
        _vm.notiFlag('warning')
      }
    }
  }, [_vm._v("Open Warning Flag")])], 1), _vm._v(" "), _c('h3', {
    staticClass: "mt-font--body20"
  }, [_vm._v("Success")]), _vm._v(" "), _c('div', {
    staticClass: "mt--text-right"
  }, [_c('mt-button', {
    attrs: {
      "type": "secondary-gray"
    },
    on: {
      "click": function($event) {
        _vm.notiFlag('success')
      }
    }
  }, [_vm._v("Open Success Flag")])], 1), _vm._v(" "), _c('h3', {
    staticClass: "mt-font--body20"
  }, [_vm._v("Information")]), _vm._v(" "), _c('div', {
    staticClass: "mt--text-right"
  }, [_c('mt-button', {
    attrs: {
      "type": "secondary-gray"
    },
    on: {
      "click": function($event) {
        _vm.notiFlag('info')
      }
    }
  }, [_vm._v("Open Information Flag")])], 1), _vm._v(" "), _c('h3', {
    staticClass: "mt-font--body20"
  }, [_vm._v("Auto Close (3s)")]), _vm._v(" "), _c('div', {
    staticClass: "mt--text-right"
  }, [_c('mt-button', {
    attrs: {
      "type": "secondary-gray"
    },
    on: {
      "click": function($event) {
        _vm.notiFlagAutoClose()
      }
    }
  }, [_vm._v("Open Information Flag")])], 1), _vm._v(" "), _c('h3', {
    staticClass: "mt-font--body20"
  }, [_vm._v("Close Callback")]), _vm._v(" "), _c('div', {
    staticClass: "mt--text-right"
  }, [_c('mt-button', {
    attrs: {
      "type": "secondary-gray"
    },
    on: {
      "click": _vm.callbackClose
    }
  }, [_vm._v("Open Flag, Close Callback")])], 1), _vm._v(" "), _c('div', {
    staticClass: "style"
  }, [_c('h2', [_vm._v("Style")]), _vm._v(" "), _c('h3', [_vm._v("Colors")]), _vm._v(" "), _c('div', {
    staticClass: "left mt--bg--neutrals-light-gray-01 height250"
  }, [_c('img', {
    attrs: {
      "src": _vm.notiFlagColorsError,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "mt--clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "left mt--bg--neutrals-light-gray-01 height250"
  }, [_c('img', {
    attrs: {
      "src": _vm.notiFlagColorsWarning,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "mt--clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "left mt--bg--neutrals-light-gray-01 height250"
  }, [_c('img', {
    attrs: {
      "src": _vm.notiFlagColorsSuccess,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(2, false, false), _vm._v(" "), _c('div', {
    staticClass: "mt--clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "left mt--bg--neutrals-light-gray-01 height250"
  }, [_c('img', {
    attrs: {
      "src": _vm.notiFlagColorsInformation,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(3, false, false), _vm._v(" "), _c('div', {
    staticClass: "mt--clearfix"
  }), _vm._v(" "), _c('h3', [_vm._v("Sizing")]), _vm._v(" "), _c('div', {
    staticClass: "left mt--bg--neutrals-light-gray-01 height250"
  }, [_c('img', {
    attrs: {
      "src": _vm.sizing,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(4, false, false), _vm._v(" "), _c('h3', [_vm._v("Position")]), _vm._v(" "), _c('div', {
    staticClass: "left mt--bg--neutrals-light-gray-01 imgbox"
  }, [_c('img', {
    attrs: {
      "src": _vm.position,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(5, false, false)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right mt-font--body10"
  }, [_c('p', [_vm._v("Bar: #F44336")]), _vm._v(" "), _c('p', [_vm._v("Border: #B2C0D0")]), _vm._v(" "), _c('p', [_vm._v("Icon: #F44336, #485464  opacity 80%")]), _vm._v(" "), _c('p', [_vm._v("Text: #485464")]), _vm._v(" "), _c('p', [_vm._v("Subtitle: #718091")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right mt-font--body10"
  }, [_c('p', [_vm._v("Bar: #FFC107")]), _vm._v(" "), _c('p', [_vm._v("Border: #B2C0D0")]), _vm._v(" "), _c('p', [_vm._v("Icon: #FFC107, #485464  opacity 80%")]), _vm._v(" "), _c('p', [_vm._v("Text: #485464")]), _vm._v(" "), _c('p', [_vm._v("Subtitle: #718091")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right mt-font--body10"
  }, [_c('p', [_vm._v("Bar: #00C853")]), _vm._v(" "), _c('p', [_vm._v("Border: #B2C0D0")]), _vm._v(" "), _c('p', [_vm._v("Icon: #00C853, #485464  opacity 80%")]), _vm._v(" "), _c('p', [_vm._v("Text: #485464")]), _vm._v(" "), _c('p', [_vm._v("Subtitle: #718091")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right mt-font--body10"
  }, [_c('p', [_vm._v("Bar: #7364FF")]), _vm._v(" "), _c('p', [_vm._v("Border: #B2C0D0")]), _vm._v(" "), _c('p', [_vm._v("Icon: #7364FF, #485464  opacity 80%")]), _vm._v(" "), _c('p', [_vm._v("Text: #485464")]), _vm._v(" "), _c('p', [_vm._v("Subtitle: #718091")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right mt-font--body10 height198"
  }, [_c('p', [_vm._v("Corner radius: 2px")]), _vm._v(" "), _c('p', [_vm._v("Width: auto")]), _vm._v(" "), _c('p', [_vm._v("Minimum width: 350px")]), _vm._v(" "), _c('p', [_vm._v("Height: 120px")]), _vm._v(" "), _c('p', [_vm._v("Border: 0.5px")]), _vm._v(" "), _c('p', [_vm._v("Font size: 16px")]), _vm._v(" "), _c('p', [_vm._v("Line height: 24px")]), _vm._v(" "), _c('p', [_vm._v("Font size(subtitle): 14px")]), _vm._v(" "), _c('p', [_vm._v("Line height(subtitle): 22px")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right mt-font--body10"
  }, [_c('p', [_vm._v("Corner radius: 2px")]), _vm._v(" "), _c('p', [_vm._v("Width: auto")]), _vm._v(" "), _c('p', [_vm._v("Minimum width: 350px")]), _vm._v(" "), _c('p', [_vm._v("Height: 120px")]), _vm._v(" "), _c('p', [_vm._v("Border: 0.5px")]), _vm._v(" "), _c('p', [_vm._v("Font size: 16px")]), _vm._v(" "), _c('p', [_vm._v("Line height: 24px")]), _vm._v(" "), _c('p', [_vm._v("Font size(subtitle): 14px")]), _vm._v(" "), _c('p', [_vm._v("Line height(subtitle): 22px")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df48b082","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotificationFlag.vue
// module id = ktwd
// module chunks = 0